<template>
  <div :class="spver === 1 ? 'img-default-film' : 'img-default-sogou'">
    <img
      v-if="lazy"
      v-lazy="src"
      @error="imgerr"
    >
    <img
      v-else
      :src="src"
      @error="imgerr"
    >
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: '',
    },
    spver: {
      type: String,
      default: '',
    },
    lazy: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    imgerr(env) {
      env.target.style.display = 'none'; // eslint-disable-line
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_home.scss';

.img-default-sogou {
  &:before {
    content: '';
    @extend %-absolute-center;
    @include sprite-item('home/sogou');
    z-index: -1;
  }
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.05);
  }
}

.img-default-film {
  &:before {
    content: '';
    @extend %-absolute-center;
    @include sprite-item('home/film');
    z-index: -1;
  }
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.05);
  }
}
</style>
